// extracted by mini-css-extract-plugin
module.exports = {"icon":"ToTopArrow_icon_1W_j9","button":"ToTopArrow_button_3h6Nh"};